import { humanize } from 'inflection'
import { useMemo } from 'react'
import { FlowTriggerConfigMap } from '../../constants'
import { FlowNodeTypes, type NodeDataBase } from '../../types'
import { getOutputStateName, TriggerStringToFlowTypeMap } from '../../utils'
import type { NodeExecutedEvent } from '../types'

export const getChosenPathLabel = (node: NodeExecutedEvent) => {
  if (!node.chosen_path) return 'No path chosen'
  if (node.previous_node_type === FlowNodeTypes.start) {
    const mappedFlowType = TriggerStringToFlowTypeMap[node.chosen_path]
    return (mappedFlowType && FlowTriggerConfigMap[mappedFlowType]?.title) ?? node.chosen_path
  }

  const outputStateLabel = getOutputStateName(
    node.previous_node_type as FlowNodeTypes,
    {
      allowed_inputs: [node.chosen_path],
    } as NodeDataBase['config'],
    node.chosen_path,
  )

  return outputStateLabel || humanize(node.chosen_path)
}

export const ChosenPath = ({ node }: { node: NodeExecutedEvent }) => {
  const chosenPathLabel = useMemo(() => getChosenPathLabel(node), [node])

  return (
    <div className="font-inter text-xs-400 text-secondary break-words capitalize">
      {chosenPathLabel}
    </div>
  )
}
